import { render } from "./SystemError.vue?vue&type=template&id=a6457560&scoped=true"
const script = {}

import "./SystemError.vue?vue&type=style&index=0&id=a6457560&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6457560"]])

export default __exports__